import { Box, Typography, styled } from "@mui/material";

const StyledBox = styled(Box)(({ theme }) => ({
  boxShadow: `0px 0px 15px rgba(169, 80, 82, 0.5)`,
  border: `1px solid ${theme.palette.divider}`,
  paddingTop: "15px",
  paddingBottom:"35px",
  paddingLeft:"30px",
  paddingRight:"30px",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  height: "50%",
  [theme.breakpoints.down("md")]: {
    height: "auto",
  },
}));

const AchievementCard = ({ title, description }) => {
  return (
    <StyledBox>
      <Typography variant="h3" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="h5" color="text.primary">
        {description}
      </Typography>
    </StyledBox>
  );
};

export default AchievementCard;
